{
  "version": 1,
  "asset_id": "c340d6b5-ae08-4bbe-9865-3177c70f9c2f",
  "project_id": "7580f3ab-e7a4-418d-abe6-5eb616986e51",
  "url": "/__l5e/assets-v1/c340d6b5-ae08-4bbe-9865-3177c70f9c2f/hernando-galvalume-metal-roof-destination-roofing-768w.avif",
  "r2_key": "a/v1/7580f3ab-e7a4-418d-abe6-5eb616986e51/c340d6b5-ae08-4bbe-9865-3177c70f9c2f/hernando-galvalume-metal-roof-destination-roofing-768w.avif",
  "original_filename": "hernando-galvalume-metal-roof-destination-roofing-768w.avif",
  "size": 44589,
  "content_type": "image/avif",
  "created_at": "2026-07-21T19:37:41Z"
}
